import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {BonusStatus, BonusStatusInfo} from "@/store/shop/types";
import BonusPointUtils from "@/utils/bonus-point-utils";
import {Link} from "@/scenes.ui/link";
import {SpaceTr, SpaceTrSpace, Tr, TrSpace} from "@/i18n/i18n";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class BonusStatusPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, bi: BonusStatusInfo, showManual: () => unknown) {
        super(scene);

        this.scene = scene;

        if (bi.status === BonusStatus.NONE) {
            this.height = 100;
        } else {
            this.height = 240;
        }

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height + 60);
        this.add(back);

        let yy = 30;

        if (bi.status !== BonusStatus.NONE) {

            let pointsText = TextUtils.addTextAdvanced(scene, Tr('pnts') + ': ' + String(bi.points), 0, yy,
                '#56ff38', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

            let validText = TextUtils.addTextAdvanced(scene, TrSpace('before.obs') + bi.remainTime, 0, pointsText.y / CU.S + 20,
                '#d5d5d5', 11, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR).setVisible(bi.points > 0);

            let statusText = TextUtils.addTextAdvanced(scene, BonusPointUtils.getStatusNominative(bi.status) + SpaceTr('stts'), 0, validText.y / CU.S + 42,
                '#ffc52b', 12, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

            let descText = TextUtils.addTextAdvanced(scene, Tr('pnts').toLowerCase() + ': ' + String(bi.currentBonusPercent) + Tr('pct.gms'), 0, statusText.y / CU.S + 20,
                '#afafaf', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

            this.add([pointsText, validText, statusText, descText]);

            yy = descText.y / CU.S + 60;
        }

        let prefix = bi.remainTillNextStatus === 10000 ? TrSpace('ag.buy') : TrSpace('ag.buy.mr');

        let nxtTxt = bi.status === BonusStatus.BRILLIANT ? Tr('mx.st') : prefix + String(bi.remainTillNextStatus) + SpaceTrSpace('buy.get')
            + BonusPointUtils.getStatusNominative(bi.nextStatus).toLowerCase() + SpaceTr('stts').toLowerCase() + '.';

        let nextText = TextUtils.addTextAdvanced(scene, nxtTxt, 0, yy,
            '#afafaf', 12, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let manual = new Link(scene, 0, nextText.y + 30 * CU.S, Tr('det').toLowerCase(), showManual,
            '#afafaf', 12, 0.5);

        this.add([nextText, manual]);

        const sep = SpriteUtils.addSprite(this.scene!, 0, manual.y / CU.S + 35, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5).setOrigin(0.5, 0.5);

        this.add(sep);
    }

}
